const reportError = (error, customData) => {
  console.log(error, customData);
};

export { reportError };
